import React from "react";
import { Grid, Segment, Table } from "semantic-ui-react";

import { SortType, WorkstationTypes } from "./../../../utils/Constants";
import { getLimaURLByShopId } from "./../../../utils/TextConfigUtil";

const CustomerDetails = ({ currentBox }) => {
  const addressToHtml = (address) => {
    let arr = address.split(/<br\s*\/?>/i);
    return arr.reduce((el, a, i) => el.concat(a, <br key={i} />), []);
  };

  const isAframe = (type) => {
    return (
      [SortType.AFRAME, SortType.AFRAMEMIXEDSINGLE, SortType.AFRAMEMIXEDNORMAL].indexOf(type) > -1
    );
  };

  const getWorkstationTypeString = (workstationType) => {
    switch (workstationType) {
      case WorkstationTypes.AutoPackMixedSmall:
      case WorkstationTypes.AutoPackSmall:
      case WorkstationTypes.AutoPackWestMixedSmall:
        return "S";
      case WorkstationTypes.AutoPackMixedMedium:
      case WorkstationTypes.AutoPackMedium:
      case WorkstationTypes.AutoPackWestMixedMedium:
        return "M";
      case WorkstationTypes.AutoPackLarge:
        return "L";
      case WorkstationTypes.AutoPackXLarge:
        return "XL";
      default:
        return "";
    }
  };

  const getSortTypeString = (sortType, workstationType) => {
    switch (sortType) {
      case SortType.AFRAME:
        return "AFRAME";
      case SortType.AFRAMEMIXEDSINGLE:
      case SortType.AFRAMEMIXEDNORMAL:
        return "AFRAME-" + getWorkstationTypeString(workstationType);
      default:
        return "NORMAL";
    }
  };

  const packOperator = (packInfo) => {
    if (packInfo.prefill && packInfo.operatorID !== -1) {
      return (
        <Table.Row>
          <Table.Cell>Prefilled av</Table.Cell>
          <Table.Cell>{packInfo.operatorName}</Table.Cell>
        </Table.Row>
      );
    } else if (!packInfo.prefill && packInfo.operatorID !== -1) {
      return (
        <Table.Row>
          <Table.Cell>Packad av</Table.Cell>
          <Table.Cell>{packInfo.operatorName}</Table.Cell>
        </Table.Row>
      );
    } else {
      return null;
    }
  };

  const packStation = (packInfo) => {
    if (packInfo.prefill && packInfo.workstationID !== -1) {
      return (
        <Table.Row>
          <Table.Cell>Prefillstation</Table.Cell>
          <Table.Cell>{packInfo.workstationID}</Table.Cell>
        </Table.Row>
      );
    } else if (!packInfo.pbl && packInfo.workstationID !== -1) {
      return (
        <Table.Row>
          <Table.Cell>Packstation</Table.Cell>
          <Table.Cell>{packInfo.workstationID}</Table.Cell>
        </Table.Row>
      );
    } else {
      return null;
    }
  };

  const pblStation = (packInfo) => {
    if (packInfo.pbl && packInfo.pblStation !== "none") {
      return (
        <Table.Row>
          <Table.Cell>PBLStation</Table.Cell>
          <Table.Cell>{packInfo.pblStation}</Table.Cell>
        </Table.Row>
      );
    } else {
      return null;
    }
  };

  return (
    <Segment size="large" style={{ minHeight: "130px" }}>
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <Table basic="very" compact="very" color="green">
              <Table.Body>
                {currentBox.boxBarcode ? (
                  <Table.Row>
                    <Table.Cell>Låda</Table.Cell>
                    <Table.Cell>{currentBox.boxBarcode}</Table.Cell>
                  </Table.Row>
                ) : null}
                <Table.Row>
                  <Table.Cell>Order</Table.Cell>
                  <Table.Cell>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        getLimaURLByShopId(currentBox.orderShopID) +
                        "/Order/" +
                        currentBox.orderNumber
                      }
                    >
                      {currentBox.orderNumber}
                    </a>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Faktura</Table.Cell>
                  <Table.Cell>{currentBox?.invoice?.invoiceNumber}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Ordertyp</Table.Cell>
                  <Table.Cell>
                    {
                      <b>
                        {getSortTypeString(currentBox.sortType, currentBox.workstationType)}
                        {isAframe(currentBox.sortType) ? (
                          <img class="SSIImage" src={process.env.PUBLIC_URL + "/images/ssi.png"} />
                        ) : (
                          ""
                        )}
                      </b>
                    }
                  </Table.Cell>
                </Table.Row>
                {packOperator(currentBox.packedByInfo)}
                {packStation(currentBox.packedByInfo)}
                {pblStation(currentBox.packedByInfo)}
              </Table.Body>
            </Table>
          </Grid.Column>
          <Grid.Column>
            <div className="CustomerDetails">{addressToHtml(currentBox.addressFormatted)}</div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default CustomerDetails;
